import styled from 'styled-components';

export const TimelineContainer = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 8px;
	box-sizing: border-box;
	overflow: hidden;
`;

export const TimelineFrame = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	flex: 1;
	min-height: 0;
	overflow: hidden;
`;

export const RulerContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
	height: 2.5rem;
	position: relative;
	width: 100%;
	overflow: hidden;
	box-sizing: border-box;

	@media (max-width: 480px) {
		height: 45px;
		gap: 2px;
	}
`;

export const StyledCanvas = styled.canvas`
	width: 100%;
	height: 100%;
	max-width: 100%;
	cursor: pointer;
	display: block;
	box-sizing: border-box;
	user-select: none;
	-webkit-user-drag: none;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
`;

export const TimeLabelsContainer = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	gap: 8px;
	flex-shrink: 0;

	@media (max-width: 480px) {
		padding: 0 2px;
		gap: 4px;
	}
`;

export const TimeLabel = styled.span`
	font-family: inherit;
	font-weight: 400;
	font-size: 12px;
	line-height: 1.2;
	color: ${({ theme }) => theme.palette.secondary[400]};
	white-space: nowrap;
	user-select: none;
	padding: 0 12px;

	@media (max-width: 480px) {
		font-size: 10px;
	}
`;

export const TimeTooltip = styled.div<{ $x: number; $y: number }>`
	position: fixed;
	left: ${({ $x }) => $x}px;
	top: ${({ $y }) => $y}px;
	transform: translate(-50%, calc(-100% + 10px));
	background: rgba(0, 0, 0, 0.9);
	color: white;
	padding: 6px 10px;
	border-radius: 4px;
	font-size: 12px;
	font-family: inherit;
	font-weight: 500;
	white-space: nowrap;
	pointer-events: none;
	z-index: 1000;
	user-select: none;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

	&::after {
		content: '';
		position: absolute;
		top: 100%;
		left: 50%;
		transform: translateX(-50%);
		width: 0;
		height: 0;
		border-left: 5px solid transparent;
		border-right: 5px solid transparent;
		border-top: 5px solid rgba(0, 0, 0, 0.9);
	}
`;
